import { withSidebar } from "../hoc/withSidebar";
import { useTranslation } from "react-i18next";
import Header from "../../components/Header/Header";
import React from "react";
import { useSelector } from "react-redux";
import CommonContainerBox from "../custom/containers/CommonContainerBox";

import ChangePassword from "../User/ChangePassword";
import BillerProfile from "../User/BillerProfile";
import ConfirmationMessage from "../custom/containers/ConfirmationMesssage";
import Footer from "../Footer/Footer";
import { getServiceAgreement } from "../../utils/helper";
import { ResponsiveBox, Tab, Tabs, Typography } from "../primitives";

const AccountRegistration = (props) => {
  const { t } = useTranslation();

  let user = useSelector((state) => state.loginUserReducer.user);

  const serviceAgreement = getServiceAgreement(user);

  const hasUserUpdated = useSelector(
    (state) => state.loginUserReducer?.message
  );
  const hasUserPasswordUpdated = useSelector(
    (state) => state.userPasswordReducer?.user?.message
  );

  const {
    location: { state },
  } = props;

  return (
    <>
      <Header {...props} />
      <div role="main">
        <CommonContainerBox
          title={t("erps.accountRegistration.formtitle.message")}
          marginTop="100px"
          padding="0px 24px 0px 24px"
          minHeight="calc(100vh - 280px)"
        >
          {hasUserUpdated && <ConfirmationMessage message={hasUserUpdated} />}
          {hasUserPasswordUpdated && (
            <ConfirmationMessage message={hasUserPasswordUpdated} />
          )}
          <ResponsiveBox ml={3}>
            <ResponsiveBox mt={2}>
              <Typography variant="h1">
                {t("erps.welcome.page.title", "Welcome")}
              </Typography>
            </ResponsiveBox>
            <ResponsiveBox mt={2}>
              <Typography variant="body1">
                {t("erps.welcome.page.accountsettings.description", {
                  fi_name: serviceAgreement?.fileName,
                  service_name: serviceAgreement?.serviceName,
                  referrer_service_name: serviceAgreement?.referrerServiceName,
                  profile_update_submsg: serviceAgreement?.profileUpdateSubmsg
                })}
              </Typography>
            </ResponsiveBox>
            <ResponsiveBox mt={6}>
              <Typography variant="h2">
                {t("erps.accountsettings.label", "Account settings")}
              </Typography>
            </ResponsiveBox>
            <ResponsiveBox mt={2}>
              <Typography variant="body1">
                {t(
                  "erps.billerregistration.label.registration.required",
                  "All fields are required in order to complete registration."
                )}
              </Typography>
            </ResponsiveBox>
            <ResponsiveBox sx={{ width: "100%" }}>
              <ResponsiveBox
                sx={{
                  borderBottom: 1,
                  borderColor: "divider",
                  marginTop: "1.5rem",
                }}
              >
                <BillerProfile
                  {...props}
                  profileId={user?.userId}
                  pageName="account-registration"
                />
              </ResponsiveBox>
            </ResponsiveBox>
          </ResponsiveBox>
        </CommonContainerBox>
      </div>
      <Footer />
    </>
  );
};

export default AccountRegistration;
